import cn from 'classnames';
import dayjs from 'dayjs';
import { useState } from 'react';
import { Button } from '../../../../../../components/button/button';
import { Chip } from '../../../../../../components/chip/chip';
import { Modal, ModalProps } from '../../../../../../components/modal/modal';
import { TextArea } from '../../../../../../components/textarea/textarea';
import { useLang } from '../../../../../../hooks/use-lang';
import {
  StatementStatusType,
  StatementType,
  StatementTypeType,
} from '../../../../../../store/api/statements-api';
import { useStatementsStore } from '../../../../../../store/use-statements-store';
import s from './update-statement-status-modal.module.css';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { statementTypeTitleMap } from '../use-statements';

export const UpdateStatementStatusModal = (props: ModalProps) => {
  const { t, getLocale } = useLang();
  const { isLoading, updateStatementStatus } = useStatementsStore();

  const params = useQueryParams().getQueryParams();

  const statement = params?.statement ? (JSON.parse(params?.statement) as StatementType) : null;
  const employee = statement?.staff;
  const type = statement?.type;
  const id = statement?.id;
  const start_date = statement?.start_date;
  const end_date = statement?.end_date;
  const manager_comment = statement?.manager_comment;

  const [commentValue, setCommentValue] = useState(manager_comment);

  const updateStatus = async (status: StatementStatusType) => {
    if (!id || !status) {
      return;
    }

    try {
      await updateStatementStatus({
        id,
        status,
        manager_comment: commentValue,
      });
      props.onClose();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Modal {...props} title={t('Ответ за запрос')} className={s.feature}>
      <ul className={s.list}>
        <li className={s.item}>
          <div className={s.left}>{`${getLocale(employee?.name)} ${getLocale(
            employee?.surname,
          )}`}</div>

          <div>{t(statementTypeTitleMap[type as StatementTypeType])}</div>
        </li>

        <li className={s.item}>
          <ul className={cn(s.chips, s.left)}>
            {employee?.tags?.map((tag) => (
              <Chip variant="info" size="md" key={tag.id}>
                {tag.value}
              </Chip>
            ))}
          </ul>

          <div>{`${dayjs(start_date).format('DD.MM')} - ${dayjs(end_date).format('DD.MM')}`}</div>
        </li>
      </ul>

      <TextArea
        value={commentValue}
        onChange={(e) => setCommentValue(e.currentTarget.value)}
        name="description"
        placeholder={t('Комментарий (необязательно)')}
      />

      <div className={s.controls}>
        <Button variant="secondary" onClick={() => updateStatus('REJECTED')} className={s.cancel}>
          {t('Отказать')}
        </Button>
        <Button
          variant="danger"
          onClick={() => updateStatus('APPROVED')}
          disabled={isLoading}
          className={s.confirm}
        >
          {t('Подтвердить')}
        </Button>
      </div>
    </Modal>
  );
};
